export default __webpack_public_path__ + "static/media/PIMPIMPAUL_logo_sq.57a34af7.jpg";